export enum TimeSlotType {
  Peak = 'Peak',
  OffPeak = 'OffPeak',
  AnyTime = 'AnyTime',
  None = 'None',
}

export function getTimeSlotTypeFromString(timeSlotTypeString: string): TimeSlotType {
  return (TimeSlotType as any)[timeSlotTypeString];
}
